const MS4s = () => {
  const MS4sData = [
    {
      agency: "Arapahoe County",
      total_construction_sites: "26",
      construction_inspections_count: "403",
      construction_site_enforcement_actions: "39",
      permanent_bmps_count: "84",
      new_permanent_bmps_count: "6",
      inspections: "0",
      flood_control_facilities: "0",
    },
    {
      agency: "Douglas County",
      total_construction_sites: "1101",
      construction_inspections_count: "4528",
      construction_site_enforcement_actions: "187",
      permanent_bmps_count: "231",
      new_permanent_bmps_count: "5",
      inspections: "19",
      flood_control_facilities: "0",
    },
    {
      agency: "City of Aurora",
      total_construction_sites: "41",
      construction_inspections_count: "215",
      construction_site_enforcement_actions: "0",
      permanent_bmps_count: "29<sup>3</sup>",
      new_permanent_bmps_count: "0",
      inspections: "11",
      flood_control_facilities: "0",
    },
    {
      agency: "SEMSWA (City of Centennial) COR070000 permit",
      total_construction_sites: "2",
      construction_inspections_count: "22",
      construction_site_enforcement_actions: "0",
      permanent_bmps_count: "16",
      new_permanent_bmps_count: "0",
      inspections: "7",
      flood_control_facilities: "0",
    },
    {
      agency: "SEMSWA (City of Centennial) COR080000 permit",
      total_construction_sites: "81",
      construction_inspections_count: "1379",
      construction_site_enforcement_actions: "94",
      permanent_bmps_count: "125",
      new_permanent_bmps_count: "7",
      inspections: "13",
      flood_control_facilities: "2",
    },
    {
      agency: "City of Greenwood Village",
      total_construction_sites: "1<sup>1</sup>",
      construction_inspections_count: "5",
      construction_site_enforcement_actions: "0",
      permanent_bmps_count: "32",
      new_permanent_bmps_count: "1",
      inspections: "10",
      flood_control_facilities: "0",
    },
    {
      agency: "City of Lone Tree",
      total_construction_sites: "75",
      construction_inspections_count: "473",
      construction_site_enforcement_actions: "5",
      permanent_bmps_count: "23",
      new_permanent_bmps_count: "2",
      inspections: "22",
      flood_control_facilities: "0",
    },
    {
      agency: "City of Castle Pines",
      total_construction_sites: "40",
      construction_inspections_count: "395",
      construction_site_enforcement_actions: "3",
      permanent_bmps_count: "29<sup>4</sup>",
      new_permanent_bmps_count: "3",
      inspections: "49<sup>5</sup>",
      flood_control_facilities: "0",
    },
    {
      agency: "Town of Castle Rock",
      total_construction_sites: "609",
      construction_inspections_count: "1963",
      construction_site_enforcement_actions: "1191<sup>2</sup>",
      permanent_bmps_count: "144",
      new_permanent_bmps_count: "2",
      inspections: "308",
      flood_control_facilities: "145<sup>6</sup>",
    },
    {
      agency: "Town of Parker",
      total_construction_sites: "96",
      construction_inspections_count: "992",
      construction_site_enforcement_actions: "5",
      permanent_bmps_count: "203",
      new_permanent_bmps_count: "13",
      inspections: "416",
      flood_control_facilities: "405",
    },
    {
      agency: "CDOT",
      total_construction_sites: "56",
      construction_inspections_count: "222",
      construction_site_enforcement_actions: "20",
      permanent_bmps_count: "N/A",
      new_permanent_bmps_count: "30",
      inspections: "406",
      flood_control_facilities: "N/A",
    },
  ];

  // Declare and configure request overview table
  const MS4sTable = new requestTable({
    container: '#ms4s-table', 
    filterEnabled: false,
    tableHeaders: {
      agency: 'Agency',
      total_construction_sites: 'Total Construction Sites',
      construction_inspections_count: 'Construction Inspections',
      construction_site_enforcement_actions: 'Construction Site Enforcement Actions',
      permanent_bmps_count: 'Permanent BMPs',
      new_permanent_bmps_count: 'New Permanent BMPs',
      inspections: 'Inspections',
      flood_control_facilities: 'Flood Control Facilities',
    },
    tableActions: [],
    tableData: MS4sData,
  });
  MS4sTable.buildTable();
};
